// Moon age and Japanese tide name for a calendar date, integer arithmetic only.
// Reference new moon: 2000-01-06 18:14 UTC. Synodic month 29.530588 days.
const SYNODIC_S = 2551443;                 // 29.530588 d in seconds (rounded)
const REF_NEW_MOON = 947182440;            // unix seconds of the reference new moon

export function parseDate(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) throw new Error('date must be YYYY-MM-DD');
  return { y: +m[1], mo: +m[2], d: +m[3] };
}

// Days from 1970-01-01 for a proleptic Gregorian date (civil-from-days inverse).
export function daysFromCivil(y, mo, d) {
  y -= mo <= 2 ? 1 : 0;
  const era = Math.floor(y / 400);
  const yoe = y - era * 400;
  const doy = Math.floor((153 * (mo + (mo > 2 ? -3 : 9)) + 2) / 5) + d - 1;
  const doe = yoe * 365 + Math.floor(yoe / 4) - Math.floor(yoe / 100) + doy;
  return era * 146097 + doe - 719468;
}

// Moon age in seconds at 12:00 UTC of the date (0 .. SYNODIC_S-1).
export function moonAgeSeconds(iso) {
  const { y, mo, d } = parseDate(iso);
  const t = daysFromCivil(y, mo, d) * 86400 + 43200;
  return (((t - REF_NEW_MOON) % SYNODIC_S) + SYNODIC_S) % SYNODIC_S;
}

// Lunar day 1..30 (day 1 = new moon day).
export const lunarDay = iso => Math.floor(moonAgeSeconds(iso) / 86400) + 1;

// Illuminated fraction in per-mille, from a cosine table so it stays integer.
const COS_TABLE = Array.from({ length: 31 }, (_, i) => Math.round(Math.cos((i / 30) * Math.PI) * 1000));
export function illuminationPermille(iso) {
  const i = Math.round((moonAgeSeconds(iso) * 60) / SYNODIC_S); // 0..60 over a cycle
  const k = i <= 30 ? i : 60 - i;
  return Math.round((1000 - COS_TABLE[k]) / 2);
}

// Phase index 0..7 for icons: 0 new, 2 first quarter, 4 full, 6 last quarter.
export const phaseIndex = iso => Math.floor((moonAgeSeconds(iso) * 8 + SYNODIC_S / 2) / SYNODIC_S) % 8;

const TIDE_BY_DAY = [
  null,
  'oshio', 'oshio', 'oshio', 'nakashio', 'nakashio', 'nakashio', 'koshio', 'koshio', 'koshio', 'nagashio',
  'wakashio', 'nakashio', 'nakashio', 'oshio', 'oshio', 'oshio', 'oshio', 'oshio', 'nakashio', 'nakashio',
  'nakashio', 'koshio', 'koshio', 'koshio', 'nagashio', 'wakashio', 'nakashio', 'nakashio', 'nakashio', 'oshio',
];
export const tideName = iso => TIDE_BY_DAY[lunarDay(iso)];
